import { ArrowForwardIos } from '@mui/icons-material'
import { Stack, Divider, Button } from '@mui/material'
import { useEffect, useState } from 'react'

import { toast, ToastContainer } from 'react-toastify'

import api from 'src/Api'

import Step1 from './candidat_steps/Step1'
import Step2 from './candidat_steps/Step2'
import Step3 from './candidat_steps/Step3'
import { Check } from 'react-feather'
import Step4 from './candidat_steps/Step4'
import Step5 from './candidat_steps/Step5'
import Step6 from './candidat_steps/Step6'
export default function CandidatStepper({ user, setUser }) {
	const [activeStep, setActiveStep] = useState(1)
	const [unVerifiedSteps, setUnVerifiedSteps] = useState([...user?.unverified_steps])
	const [documents, setDocuments] = useState([...user?.documents])

	const [allDocumentsValid, setAllDocumentsValid] = useState(false);

	useEffect(() => {
	// Vérifie si tous les documents sont valides
	const validDocs = documents.every(doc => doc.is_valid);
	setAllDocumentsValid(validDocs);
	}, [documents]);

	const showError = msg => {
		toast.error(msg, {
			position: "top-center",
			autoClose: 3000,
			hideProgressBar: false,
			closeOnClick: true,
			pauseOnHover: true,
			draggable: true,
			progress: undefined,
		})
	}
	const showSuccess = msg => {
		toast.success(msg, {
			position: "top-center",
			autoClose: 3000,
			hideProgressBar: false,
			closeOnClick: true,
			pauseOnHover: true,
			draggable: true,
			progress: undefined,
		})
	}
	useEffect(() => {}, [])
	const submit = () => {
		if (unVerifiedSteps.length === 1 && unVerifiedSteps.includes(-1)) {
			api.post('/users/submit_step', { step: -1 })
				.then(res => {
					if (res.data.error === 'wait') {
						showSuccess(
							"Vos documents seront vérifiés par l'administration dans un délai de 2 jours ouvrés"
						)
					} else setUser(res.data)
				})
				.catch(err => {
					showError('Une erreur s\'est produite.')
				})
		}
	}

	return (
		<Stack spacing={2}>
			{unVerifiedSteps.length === 1 && unVerifiedSteps.includes(-1) && allDocumentsValid && (
				<Button startIcon={<Check />} variant="contained" onClick={submit}>
					Continuer
				</Button>
			)}
			{activeStep !== 0 && (
				<Stack direction={'row'} justifyContent={'space-between'} spacing={1}>
					{(unVerifiedSteps.includes(1) || unVerifiedSteps.includes(-1)) && (
						<Button
							variant={activeStep === 1 ? 'contained' : 'outlined'}
							color={unVerifiedSteps.includes(1) ? 'error' : 'success'}
							onClick={() => {
								if (activeStep === 1) setActiveStep(-1)
								else setActiveStep(1)
							}}
							sx={{ textTransform: 'none' }}
							startIcon={<ArrowForwardIos />}
						>
							Photo de profil
						</Button>
					)}

					{(unVerifiedSteps.includes(6) || unVerifiedSteps.includes(-1)) && (
						<Button
							variant={activeStep === 6 ? 'contained' : 'outlined'}
							color={unVerifiedSteps.includes(6) ? 'error' : 'success'}
							onClick={() => {
								if (activeStep === 6) setActiveStep(-1)
								else setActiveStep(6)
							}}
							sx={{ textTransform: 'none' }}
							startIcon={<ArrowForwardIos />}
						>
							Adresse
						</Button>
					)}

					{(unVerifiedSteps.includes(2) || unVerifiedSteps.includes(-1)) && (
						<Button
							variant={activeStep === 2 ? 'contained' : 'outlined'}
							color={unVerifiedSteps.includes(2) ? 'error' : 'success'}
							onClick={() => {
								if (activeStep === 2) setActiveStep(-1)
								else setActiveStep(2)
							}}
							sx={{ textTransform: 'none' }}
							startIcon={<ArrowForwardIos />}
						>
							Documents
						</Button>
					)}
					{(unVerifiedSteps.includes(3) || unVerifiedSteps.includes(-1)) && (
						<Button
							variant={activeStep === 3 ? 'contained' : 'outlined'}
							color={unVerifiedSteps.includes(3) ? 'error' : 'success'}
							onClick={() => {
								if (activeStep === 3) setActiveStep(-1)
								else setActiveStep(3)
							}}
							sx={{ textTransform: 'none' }}
							startIcon={<ArrowForwardIos />}
						>
							Métiers
						</Button>
					)}
					{(unVerifiedSteps.includes(4) || unVerifiedSteps.includes(-1)) && (
						<Button
							variant={activeStep === 4 ? 'contained' : 'outlined'}
							color={unVerifiedSteps.includes(4) ? 'error' : 'success'}
							onClick={() => {
								if (activeStep === 4) setActiveStep(-1)
								else setActiveStep(4)
							}}
							sx={{ textTransform: 'none' }}
							startIcon={<ArrowForwardIos />}
						>
							Références
						</Button>
					)}
					{(unVerifiedSteps.includes(5) || unVerifiedSteps.includes(-1)) && (
						<Button
							variant={activeStep === 5 ? 'contained' : 'outlined'}
							color={unVerifiedSteps.includes(5) ? 'error' : 'success'}
							onClick={() => {
								if (activeStep === 5) setActiveStep(-1)
								else setActiveStep(5)
							}}
							sx={{ textTransform: 'none' }}
							startIcon={<ArrowForwardIos />}
						>
							Langue
						</Button>
					)}
				</Stack>
			)}
			<Divider />

			{activeStep === 1 && (
				<Step1 user={user} setUser={setUser} setUnVerifiedSteps={setUnVerifiedSteps} />
			)}
			{activeStep === 2 && (
				<Step2
					user={user}
					setDocuments={setDocuments}
					setUnVerifiedSteps={setUnVerifiedSteps}
				/>
			)}
			{activeStep === 3 && <Step3 user={user} setUnVerifiedSteps={setUnVerifiedSteps} />}
			{activeStep === 4 && <Step4 user={user} setUnVerifiedSteps={setUnVerifiedSteps} />}
			{activeStep === 5 && <Step5 user={user} setUnVerifiedSteps={setUnVerifiedSteps} />}
			{activeStep === 6 && <Step6 user={user} setUnVerifiedSteps={setUnVerifiedSteps} />}

			<ToastContainer
				autoClose={3000}
				hideProgressBar={false}
				newestOnTop={false}
				closeOnClick
				rtl={false}
				pauseOnFocusLoss
				draggable
				pauseOnHover
			/>
		</Stack>
	)
}
